/**
 * @file
 * Attach share button behavior.
 *
 * @see \Drupal\aw_frontend\Controller\ShareLinks
 */

(function ($, Drupal) {
  Drupal.behaviors.sharePage = {
    attach: function attach(context) {
      const triggers = once('share-url', '[data-share]', context);

      triggers.forEach(function(trigger){
        trigger.addEventListener('click', function () {
          const shareOptions = JSON.parse(this.dataset.share);
          const url = shareOptions.url ? shareOptions.url : window.location.href;
          const title = shareOptions.title ? shareOptions.title : document.title;
          const isMobile = (navigator.userAgentData && navigator.userAgentData.mobile) || /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
          // Use native share feature only if supported and intended (desktop browsers have insufficient share options).
          if (isMobile && navigator.share) {
            // Use browsers share feature / native apps.
            const text = this.dataset.shareText ? this.dataset.shareText : '';
            shareViaWebShareAPI(url, text, title);
          } else {
            // Open modal with share links.
            loadShareLinks(this, url, title);
          }
        });
      });
    }
  };

  /**
   * Share URL with native apps via Web Share API.
   *
   * @param text A string representing text to be shared.
   * @param url A string representing a URL to be shared.
   * @param title A string representing a title to be shared. May be ignored by
   *   the target.
   */
  function shareViaWebShareAPI(url, text = '', title = '') {
    navigator.share({
      url: url,
      text: text,
      title: title
    })
      .then(() => console.log('Successful share'))
      .catch(error => console.log('Error sharing:', error));
  }

  /**
   * Load dialog modal with share links.
   *
   * @param trigger The element, which is triggering the action.
   * @param url A string representing a URL to be shared.
   * @param title A string representing a title to be shared.
   */
  function loadShareLinks(trigger, url, title = '') {
    Drupal.ajax({
      url: '/share',
      submit: {
        url: url,
        title: title
      },
      dialogType: 'modal',
      dialog: {
        width: '740px',
        classes: 'ui-dialog',
        closeOnEscape: true,
        modal: true,
      },
      progress: {
        type: 'throbber'
      },
      element: trigger,
    }).execute();
  }
})(jQuery, Drupal);
